import { combineReducers } from "redux";

import authReducer from "./slice/auth";
import featureFlagsReducer from "./slice/featureFlags";
import modelReducer from "./slice/models";

const rootReducer = combineReducers({
  auth: authReducer,
  models: modelReducer,
  featureFlags: featureFlagsReducer,
});

export default rootReducer;
